import { Stack, Typography } from '@mui/material';
import { MissionSessionIcon } from '../MissionSessionIcon';

export const SessionCount = ({ count }: { count: number }) => (
    <Stack
        direction="row"
        alignItems="center"
        gap={0.25}
        component="span"
        sx={{ '& svg': { fontSize: '1rem' } }}
    >
        <Typography component="span" variant="caption">
            {count}
        </Typography>
        <MissionSessionIcon />
    </Stack>
);
